import {
  ERROR_ACTION,
  GET_INTERVIEW_LIST,
  SET_ALL_CATEGORIES_LIST,
  SET_ALL_SUBCATEGORIES_LIST,
  SET_ALL_UNAPPROVED_CUTOFF_LIST,
  SET_UNAPPROVAL_CUTOFF_PAGE_NO_COUNTER,
  SET_ALL_INTERVIEW_ATTENDEE_LIST,
  SET_ALL_INTERVIEW_ABSENTEE_LIST,
  GET_CUT_OFF_LIST,
  SET_QUALIFYING_CANDIDATES_LIST,
  SET_RESERVATION_DATA,
  SET_INTERVIEW_QUALIFIED_CANDIDATE_DATA,
  SET_VENUE_LIST,
  SET_SLAB_REPORT_DATA,
  SET_CUTOFF_CRITERIA,
  SET_INTERVIEW_LIST,
  SET_INTERVIEW_POST_PREFERENCE_LIST,
  GET_ALL_ALLOTMENT_CHART_DATA,
  SET_ALL_DUPLICATE_CODE_DATA,
  SET_UNAPPROVAL_INTERVIEW_CRITERIA_PAGE_NO_COUNTER,
  SET_ALL_UNAPPROVED_INTERVIEW_CRITERIA_LIST,
  SET_ALL_UNAPPROVED_RECOMMENDATION_CRITERIA_LIST,
  SET_UNAPPROVAL_RECOMMENDATION_CRITERIA_PAGE_NO_COUNTER,
  SET_RECOMMENDATION_CUTOFF_LIST,
  GET_INTERVIEW_QUALIFIED_CANDIDATE,
  SET_RECOMMENDATION_VIGATVARI_DATA,
  SET_INTERVIEW_SCHEDULE,
  SET_REVISED_INTERVIEW_SCHEDULE,
  SET_INTERVIEW_LETTER,
  GET_STAGE_LIST,
  GET_RECOMMENDATION_CRITERIA_VIEW
} from "../../common/constants/ActionTypes";

const initialState = {
  adminCategoriesList: [],
  adminSubCategoriesList: [],
  allUnapprovalCutOffList: [],
  interviewAttendeeList: [],
  interviewAbsenteeList: [],
  getCutOffList: [],
  unapprovalCutOffPageNoCounter: 0,
  qualifyingCandidatesList: [],
  allReservationData: [],
  interviewQualifiedCandidateData: [],
  venueList: [],
  getInterviewList: [],
  generalSlabReportData: [],
  getInterviewPostPreferenceList: [],
  getAllotmentChartData: [],
  getDuplicateCodeData: [],
  getinterviewCriterialist: [],
  getinterviewCriteriaCounter: [],
  getRecommendationCutOffList: [],
  getinterviewqualifiedCandidate: [],
  getRecommendationVigatvariData: [],
  getInterviewSchedule: [],
  getRevisedInterviewSchedule: [],
  getInterviewLetter: [],
  stageList: [],
  recommendationCriteriaView:[]

};

export default function interviewProcessReducer(state = initialState, action) {
  switch (action.type) {
    case ERROR_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case SET_ALL_CATEGORIES_LIST:
      return {
        ...state,
        adminCategoriesList: action.payload,
      };
    case SET_ALL_SUBCATEGORIES_LIST:
      return {
        ...state,
        adminSubCategoriesList: action.payload,
      };
    case SET_ALL_UNAPPROVED_CUTOFF_LIST:
      return {
        ...state,
        allUnapprovalCutOffList: action.payload,
      };
    case SET_UNAPPROVAL_CUTOFF_PAGE_NO_COUNTER:
      return {
        ...state,
        unapprovalCutOffPageNoCounter: action.payload,
      };
    case SET_ALL_INTERVIEW_ATTENDEE_LIST:
      return {
        ...state,
        interviewAttendeeList: action.payload,
      };
    case SET_ALL_INTERVIEW_ABSENTEE_LIST:
      return {
        ...state,
        interviewAbsenteeList: action.payload,
      };
    case GET_CUT_OFF_LIST:
      return {
        ...state,
        getCutOffList: action.payload,
      };
    case GET_INTERVIEW_LIST:
      return {
        ...state,
        getInterviewList: action.payload,
      };
    case SET_QUALIFYING_CANDIDATES_LIST:
      return {
        ...state,
        qualifyingCandidatesList: action.payload,
      };
    case SET_RESERVATION_DATA:
      return {
        ...state,
        allReservationData: action.payload,
      };
    case SET_INTERVIEW_QUALIFIED_CANDIDATE_DATA:
      return {
        ...state,
        interviewQualifiedCandidateData: action.payload,
      };
    case SET_VENUE_LIST:
      return {
        ...state,
        venueList: action.payload,
      };
    case SET_CUTOFF_CRITERIA:
      return {
        ...state,
        cutoffCriteria: action.payload,
      };
    case SET_INTERVIEW_LIST:
      return {
        ...state,
        interviewList: action.payload,
      };
    case SET_INTERVIEW_POST_PREFERENCE_LIST:
      return {
        ...state,
        getInterviewPostPreferenceList: action.payload,
      };
    case GET_ALL_ALLOTMENT_CHART_DATA:
      return {
        ...state,
        getAllotmentChartData: action.payload,
      };
    case SET_ALL_DUPLICATE_CODE_DATA:
      return {
        ...state,
        getDuplicateCodeData: action.payload,
      };
    case SET_ALL_UNAPPROVED_INTERVIEW_CRITERIA_LIST: {
      return {
        ...state,
        getinterviewCriterialist: action.payload,
      };
    }
    case SET_UNAPPROVAL_INTERVIEW_CRITERIA_PAGE_NO_COUNTER: {
      return {
        ...state,
        getinterviewCriteriaCounter: action.payload,
      };
    }
    case SET_ALL_UNAPPROVED_RECOMMENDATION_CRITERIA_LIST: {
      return {
        ...state,
        getrecommendationCriterialist: action.payload,
      };
    }
    case SET_UNAPPROVAL_RECOMMENDATION_CRITERIA_PAGE_NO_COUNTER: {
      return {
        ...state,
        getrecommendationCriteriaCounter: action.payload,
      };
    }

    case SET_SLAB_REPORT_DATA:
      return {
        ...state,
        generalSlabReportData: action.payload
      }
    case SET_RECOMMENDATION_CUTOFF_LIST:
      return {
        ...state,
        getRecommendationCutOffList: action.payload,
      };
    case GET_INTERVIEW_QUALIFIED_CANDIDATE:
      return {
        ...state,
        getinterviewqualifiedCandidate: action.payload
      }
    case SET_RECOMMENDATION_VIGATVARI_DATA:
      return {
        ...state,
        getRecommendationVigatvariData: action.payload,
      };
    case SET_INTERVIEW_SCHEDULE:
      return {
        ...state,
        getInterviewSchedule: action.payload,
      };
    case SET_REVISED_INTERVIEW_SCHEDULE:
      return {
        ...state,
        getRevisedInterviewSchedule: action.payload,
      };
    case SET_INTERVIEW_LETTER:
      return {
        ...state,
        getInterviewLetter: action.payload,
      };
    case GET_STAGE_LIST:
      return {
        ...state,
        stageList: action.payload,
      };
    case GET_RECOMMENDATION_CRITERIA_VIEW:
      return {
        ...state,
        recommendationCriteriaView: action.payload,
      };
    default:
      return state;
  }
}
